import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/team/")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/${encodeURIComponent(params.org)}/team/members` });
  },
});
